<template>
  <div class="row">
    <br />
    <div class="col-md-6 col-md-offset-3">
      <div class="confirmation-text">
        <div class="form-group form-inline text-left">
          <span>I, </span>
          <input type="text" v-model="consulterName" class="form-control" />
        </div>
        <p class="text-left">
          agree that I have discussed and understood all the information contained within this annual veterinary
          consultation.
        </p>
        <p class="text-left">
          I thereby agree to abide by the correct and safe usage, storage and withholding times of all products
          registered as veterinary medicines by the ACVM, as discussed in this consultation.
        </p>
        <p class="text-left">All medications discussed are for ANIMAL USE ONLY.</p>
        <p class="text-left">
          Use as directed. Store out of reach of children, in the appropiate environment - fridge if required, and out
          of sunlight.
        </p>
        <p class="text-left">
          I will contact VetSouth Ltd straight away should I have an adverse reaction to any drug administered that was
          prescribed by VetSouth Ltd.
        </p>

        <p class="text-left">Date: {{ today }}</p>
        <p class="text-left">
          <check-box label="Agree" @on-change="setConsultSignedAt" field-name="signed" model-name="Misc"> </check-box>
        </p>

        <div v-if="getFieldValue('signed', 'Misc') && !isReadOnly">
          <button @click="saveAndRedirectHome" type="button" class="btn btn-primary">Save and continue</button>
        </div>
      </div>
    </div>
    <br />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import baseComponent from '@/mixins/base_consult_component_v2'

export default {
  name: 'Disclaimer',
  mixins: [baseComponent],
  created() {
    this.consulterName = this.currentClientName
  },
  computed: {
    ...mapGetters('currentConsult', ['currentClientName']),
    today: function () {
      return this.$moment().format('DD/MM/YYYY')
    },
  },
  methods: {
    ...mapMutations('currentConsult', ['setConsultSignedAt']),
    saveAndRedirectHome: function () {
      this.$store.dispatch('alert/success', {
        message: 'Data has been saved locally',
        persist: true,
      })
      this.$router.push('/')
    },
  },
}
</script>

<style scoped>
.confirmation-text p {
  font-size: 20px;
}
</style>
